module.exports = "https://coursera_assets.s3.amazonaws.com/images/f6596c0f65404b2114c4053da937a223.jpg";